import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Pill } from './Pill';
import { brandName, heroBadges, heroImage, stats } from '../data/copy';
import { HERO_QUALITY, HERO_SIZES, HERO_SRC_WIDTH, HERO_WIDTHS, optimizedImage, optimizedSrcSet } from '../utils/image';
export function Hero() {
  return <header className="w-full bg-ink" data-id="element-112" data-mp="4n9wadwh9812">
      {/* Mobile: promise → mockup → details. Desktop: copy left, mockup right. */}
      <div className="mx-auto grid max-w-6xl gap-x-12 px-6 pb-8 pt-8 sm:pt-12 lg:grid-cols-[1fr_1.1fr] lg:items-center lg:pb-14 lg:pt-14" data-id="element-113" data-mp="1274p5sdm9m8t">
        <div className="text-center lg:col-start-1 lg:row-start-1 lg:self-end lg:text-left" data-id="element-114" data-mp="sai2qz5n6n4o">
          <Pill tone="accent" data-id="element-115" data-mp="ncq4lneem4s1">For futsal coaches</Pill>

          <h1 className="mt-5 font-display text-[2.5rem] font-extrabold uppercase leading-[0.92] text-fg sm:text-6xl lg:text-[4.4rem]" style={{
          fontSize: "32px"
        }} data-id="element-116" data-mp="neav91xll3km">
            Plan your next futsal session in{' '}
            <span className="text-accent" data-id="element-117" data-mp="3j8ixz1o3okvr">5 minutes</span>
          </h1>
        </div>

        <div className="relative mt-8 lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:mt-0" data-id="element-118" data-mp="3j6obvk13emq3">
          <div className="absolute inset-x-2 bottom-6 top-10 rounded-[2rem] bg-panel ring-1 ring-line" aria-hidden="true" data-id="element-119" data-mp="3o5j39ad4ljlt" />
          <img src={optimizedImage(heroImage, HERO_SRC_WIDTH, HERO_QUALITY)} srcSet={optimizedSrcSet(heroImage, HERO_WIDTHS, HERO_QUALITY)} sizes={HERO_SIZES} alt={`${brandName} complete: 6 visual coaching volumes, a session-plan tablet view, and 5 practical coaching bonuses.`} className="relative mx-auto w-full max-w-md sm:max-w-xl" width={1240} height={1240} decoding="sync" loading="eager" {...{
          fetchpriority: 'high'
        }} data-id="element-120" data-mp="3e9fuhlnrqmpw" />
        </div>

        <div className="mt-6 text-center lg:col-start-1 lg:row-start-2 lg:mt-6 lg:self-start lg:text-left" data-id="element-121" data-mp="2vj7tb93mq6cc">
          <p className="mx-auto max-w-xl text-base leading-relaxed text-muted sm:text-lg lg:mx-0" style={{
          fontSize: "13px"
        }} data-id="element-122" data-mp="2hl9sz7m58afu">
            The complete visual coaching system for futsal coaches: drills, progressions, court diagrams, pressing, transitions, quick fixes, decision-making, and ready-to-run sessions.
          </p>

          <div className="mt-7" data-id="element-123" data-mp="ibyr8h66ta4a">
            <CtaButton href="#offer" size="large" className="w-full sm:w-auto" data-id="element-124" data-mp="id9soac5u5s8">
              Get full access now
            </CtaButton>
          </div>

          <ul className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-2 lg:justify-start" data-id="element-125" data-mp="1b0vx1kt7peg5">
            {heroBadges.map(badge => <li key={badge} className="flex items-center gap-1.5 text-sm text-muted" data-id="element-126" data-mp="161ayhbhyf83y">
                <CheckIcon className="h-4 w-4 text-accent" strokeWidth={2.6} aria-hidden="true" data-id="element-127" data-mp="112g3zcamjv40" />
                {badge}
              </li>)}
          </ul>
        </div>
      </div>

      <div className="border-y border-line bg-navy" data-id="element-128" data-mp="x3h2k1o3qghb">
        <dl className="mx-auto grid max-w-6xl grid-cols-3 divide-x divide-line px-2 sm:px-6" data-id="element-129" data-mp="3lu026z6yb0yo">
          {stats.map(stat => <div key={stat.label} className="flex flex-col-reverse px-2 py-7 text-center" data-id="element-130" data-mp="3hpse948bhp1i">
              <dt className="mt-2 font-display text-xs font-semibold uppercase tracking-[0.14em] text-muted sm:text-sm" data-id="element-131" data-mp="1xam54pmyxoye">
                {stat.label}
              </dt>
              <dd className="font-display text-5xl font-extrabold leading-none text-accent sm:text-6xl" data-id="element-132" data-mp="269hc43xu732r">
                {stat.value}
              </dd>
            </div>)}
        </dl>
        <p className="border-t border-line bg-accent py-3 text-center font-display text-sm font-bold uppercase tracking-[0.4em] text-on-accent" data-id="element-133" data-mp="2fzsqkkf5cunw">
          Courtside ready
        </p>
      </div>
    </header>;
}